<div class="master-modal reviepw_items_modal" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <!-- Modal-Header -->
        <div class="modal-header">
          <h4 class="modal-title"> Followers </h4>
          <div class="modal_close_btn">
            <span (click)="closeDialog()" class="modal-close"><i class="material-icons">close</i></span>
          </div>
        </div>

        
        <!-- Modal content-->
        <!-- <perfect-scrollbar class="modal-body-scrollbar"> -->
          <div mat-dialog-content>
            <!-- Modal-Body -->
            <div class="modal-body">
              <div class="followers_list_box" *ngFor="let foing of data">
                <div class="media">
                  <div class="media-left" *ngIf="foing.type == 'PROFESSIONAL'" >
                    <img [src]="foing?.profile_image?.url">
                  </div>
                  <div class="media-left" *ngIf="foing.type !== 'PROFESSIONAL'" >
                    <img [src]="foing?.logo?.url"
                    onerror="this.src='../../../../../assets/images/user-placeholder.jpg'">
                  </div>
                  <div class="media-body">
                    <h4>{{foing?.name}}</h4>
                    <p>{{foing?.profession_type}} </p>
                    <p *ngIf="foing?.abn_number">Abn/Acn: {{foing?.abn_number}} </p>
                  </div>
                </div>
                <!-- <button class="btn btn-sm global-btn" (click)="unFollow(foing)" mat-button>unfollow</button> -->
              </div>
            </div>
          </div>
        <!-- </perfect-scrollbar> -->
        <!-- Modal-Footer -->
        <!-- <div class="modal-footer">
            <div mat-dialog-actions class="modal_footer">
              <button mat-button (click)="closeDialog()" class="modal-cancel-btn modal-footer-btn">
                <span>Cancel</span>
              </button>
              <button type="submit" mat-button class="modal-save-btn global-btn modal-footer-btn" (click)="closeDialog()" >
                <span>Send enquiry </span>
              </button>
            </div>
          </div> -->
      </div>
    </div>
  </div>
  